import { actions } from '@/modules/Contact/store/actions';
import { getters } from '@/modules/Contact/store/getters';
import { mutations } from '@/modules/Contact/store/mutations';
import { ContactState, state } from '@/modules/Contact/store/state';
import { RootState } from '@/plugins/store';
import { Module } from 'vuex';

const module: Module<ContactState, RootState> = {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};

export default module;
export type { ContactState };

